import Vue from 'vue'
import VueRouter from 'vue-router'

import Search from './components/Search.vue'
import FeaturePerformance from './components/data-items/FeaturePerformance.vue'
import FeatureCastMember from './components/data-items/FeatureCastMember.vue'
import FeatureAuthor from './components/data-items/FeatureAuthor.vue'
import FeaturePlay from './components/data-items/FeaturePlay.vue'
import FeatureTroupe from './components/data-items/FeatureTroupe.vue'

Vue.use(VueRouter);

export const routes = [
  { name: 'search', path: '/search', component: Search },
  { name: 'feature-performance', path: '/performances/:id', component: FeaturePerformance },
  { name: 'feature-member', path: '/member/:id', component: FeatureCastMember },
  { name: 'feature-author', path: '/author/:id', component: FeatureAuthor },
  { name: 'feature-play', path: '/play/:id', component: FeaturePlay },
  { name: 'feature-troupe', path: '/troupe/:id', component: FeatureTroupe },
  { path: '/', redirect: 'search' }
]

export default new VueRouter({
  routes
})
